// extracted by mini-css-extract-plugin
export default {"accountMenu":"src-hellospa-components-global-header-account-menu__accountMenu--6pFq9"};